const styles = {
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    zIndex: 1201,
    left: 0,
    top: 0,
    backgroundColor: "rgba(255,255,255,0.8)",
    width: "100%",
    height: "100vh",
  },
  icon: {
    transform: "translate(-50%, -50%)",
  },
};

export default styles;
